import React, { useEffect, useRef, useState } from 'react';
import 'whatwg-fetch';
import TopBar from 'src/scenes/components/nav/TopBar';
import Sidemenu from 'src/scenes/components/Sidemenu';
import MyToast from 'src/scenes/components/toast/toast';
import DashboardRouter from 'src/scenes/DashboardRouter';
import { DrawerProvider } from 'src/hooks/useDrawer';
import { Redirect } from 'react-router';
import useAuth from 'src/hooks/api/useAuth';
import useLegacyUser from 'src/hooks/api/useLegacyUser';
import { LegacyUser } from 'src/interfaces/api/User';
import { AgenciesContextProvider } from 'src/hooks/api/useAgencies';

const Dashboard = ({ history, match }) => {
  const { authenticated } = useAuth();
  const { getMe } = useLegacyUser();

  const [user, setUser] = useState<LegacyUser>();
  const [isBlackOut, setIsBlackOut] = useState(false);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [isToastAnim, setIsToastAnim] = useState(false);
  const [toastText, setToastText] = useState<{ title?: string; message?: string; success?: boolean }>({
    title: undefined,
    message: undefined,
    success: undefined,
  });

  const timeoutId = useRef<any>();
  const timeoutId2 = useRef<any>();

  const toggleBlackOut = () => {
    setIsBlackOut((blackout) => !blackout);
  };

  useEffect(() => {
    getMe().then((user) => {
      setUser(user);
    });

    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      if (timeoutId2.current) {
        clearTimeout(timeoutId2.current);
      }
    };
  }, []);

  if (!authenticated) {
    return <Redirect to='/' />;
  }

  const openToast = (success: boolean, message: string, title = '') => {
    setToastText({
      title: title,
      message: message,
      success: success,
    });
    setIsToastOpen(true);

    timeoutId.current = setTimeout(() => {
      setIsToastAnim(true);
    }, 10);

    timeoutId2.current = setTimeout(() => {
      setIsToastAnim(false);
    }, 3000);
  };

  return (
    <DrawerProvider>
      <AgenciesContextProvider>
        <div id='blackOut' className={isBlackOut ? 'modal ' : ''} />

        <MyToast className='myToast' toastText={toastText} isOpen={isToastOpen} isAnim={isToastAnim} />

        <TopBar history={history} user={user} />

        <Sidemenu />

        <DashboardRouter
          match={match}
          history={history}
          user={user}
          openToast={openToast}
          toggleBlackOut={toggleBlackOut}
        />
      </AgenciesContextProvider>
    </DrawerProvider>
  );
};

export default Dashboard;
